const keyMirror = require("keymirror");

export const LoginConstant = keyMirror({
  CHECK_LOGIN: undefined,
});
